import defineComponent from 'flight';
import riot from 'riot';
import observable from 'static/script/app/ui/checkout2/context/observable';
import modal from 'static/script/app/ui/checkout2/context/modal';
import payment from 'static/script/app/ui/checkout2/context/payment';

let context = {
    observable: observable,
    modal: modal,
    payment: payment
};

context.init = function(model) {
    riot.mount('checkout-payment', { model: model });
};

module.exports = context;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/context/context.js